import React, {useEffect, useState} from 'react';
import { useHistory, useParams, useLocation, useRouteMatch } from "react-router-dom";
import {LocationDescriptorObject} from 'history';
import _ from 'lodash';
import Languages from 'locales';

interface Props {
  children?: React.ReactNode
}


interface ReactRouterContextProps  {
  historyWithLangPush(options:string | object):void;
  getWithLangPath(options:string | object):string | LocationDescriptorObject
}

export const ReactRouterContext = React.createContext({} as ReactRouterContextProps);

const ReactRouter = (props:Props) => {
  const params:{lang?:string} = useParams()
  const { lang } = params;
  const routeMatch = useRouteMatch();
  const routeLocation = useLocation();
  const history = useHistory();
  const LangsKeys = _.values(Languages);
  const langPathMerage = LangsKeys.length > 1 ? _.chain(LangsKeys).reduce((a,b) => a.keys +  `|${b.keys}`).value() : LangsKeys[0].keys;
  const langPathRegex = `^/${_.chain(langPathMerage.split('|')).reduce((a,b) => `${a}` +  `|^/${b}`).value()}`
  const matchLang:any = routeLocation.pathname.match(new RegExp(langPathRegex));
  let langPath:string = lang || ''
  if(!!matchLang) {
    langPath = matchLang.input.split('/')[1];
  }
  langPath =  `${langPath && langPath != '404' ? `/${langPath}` : ''}`;

  const historyWithLangPush = function(options:string | LocationDescriptorObject) {
    let location;
    if(typeof options === 'string') {
      location = langPath + options;
    } else {
      location = _.cloneDeep(options);
      location.pathname = langPath + options.pathname
    }
    history.push(location)
  }
  
  const getWithLangPath = function(options:string | LocationDescriptorObject) {
    // const langPath:string = `${lang && lang != '404' ? `/${lang}` : ''}`;
    let location;
    if(typeof options === 'string') {
      location = langPath + (options == '/' ? '' : options);
    } else {
      location = _.cloneDeep(options);
      location.pathname = langPath + (options.pathname == '/' ? '' : options.pathname)
    }
 
    return location;
  }

  return (
    <ReactRouterContext.Provider value={{historyWithLangPush, getWithLangPath}}>
      {props.children}
    </ReactRouterContext.Provider>
  )
}

export default ReactRouter;